import React, { useRef } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import ListPageHeader from '@shared/ListPageHeader';
import ShippingAccountsList from '@shared/shipping_accounts/ShippingAccountsList';

import { shippingAccountService } from '@services/operator/shippingAccountService';
import { shippingTypeService } from '@services/operator/shippingTypeService';

const OperatorShippingAccountsList = () => {
  const { t } = useTranslation();
  const { merchants, loading: operatorDataLoading } = useOperatorData();
  const createFnRef = useRef(null);

  const handleCreateClick = () => {
    if (createFnRef.current) {
      createFnRef.current()();
    }
  };

  return (
    <div>
      <ListPageHeader
        items={['shipping_settings', 'shipping_settings.shipping_accounts']}
        actions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleCreateClick}
          >
            {t('common.button.new')}
          </Button>
        }
      />
      <ShippingAccountsList
        service={shippingAccountService}
        shippingTypeService={shippingTypeService}
        role="operator"
        merchants={merchants}
        merchantsLoading={operatorDataLoading}
        onCreateReady={(fn) => { createFnRef.current = fn; }}
      />
    </div>
  );
};

export default OperatorShippingAccountsList;
